export const LOKASI_OPTIONS = [
  "Kantor Pusat",
  "Cabang Jakarta",
  "Cabang Bandung",
  "Cabang Surabaya",
  "Cabang Medan",
  "Proyek Lapangan",
  "Gudang",
];

export const PENDIDIKAN_OPTIONS = ["SD", "SMP", "SMA/SMK", "D3", "S1", "S2", "S3"];
export const GENDER_OPTIONS = ["Laki-laki", "Perempuan"];
export const STATUS_OPTIONS = ["AKTIF", "PENSIUN", "RESIGN", "PHK"];

export const CHART_COLORS = ["#2563EB", "#10B981", "#E11D48", "#F59E0B", "#8B5CF6", "#0EA5E9", "#64748B"];
export const OPSI_OPTIONS = ["OPSI 1", "OPSI 2"];
export const LEVEL_OPTIONS = ["MANAGEMENT", "PENGAWAS", "OPERATOR"];
